export enum ECalendarChangeMode {
	DIET = 'diet',
	ADDRESS = 'address',
	DAYS = 'days',
	DAYS_TO = 'daysTo',
}

export enum ECalendarFilterValue {
	ALL = 'all',
}

export enum EEmployeePaymentType {
	FREE = 'free',
	PAID = 'paid',
	CART = 'cart',
	REFUND_POINTS = 'refund_points',
	IGNORE_POINTS = 'ignore_points',
}

export const EmployeePaymentTypesMap: { [key in EEmployeePaymentType]: string } = {
	[EEmployeePaymentType.FREE]: 'Za darmo',
	[EEmployeePaymentType.PAID]: 'Opłacone',
	[EEmployeePaymentType.CART]: 'Do opłacenia',
	[EEmployeePaymentType.REFUND_POINTS]: 'Przyznaj punkty',
	[EEmployeePaymentType.IGNORE_POINTS]: 'Nie przyznawaj punktów',
}

export const employeePaymentTypes = generateSelectOptions(EEmployeePaymentType, EmployeePaymentTypesMap)

export const numberOfMealsTemplate = {
	breakfast: {
		value: 1,
		label: MealTypeMap[EMealType.BREAKFAST],
	},
	second_breakfast: {
		value: 1,
		label: MealTypeMap[EMealType.SECOND_BREAKFAST],
	},
	lunch: {
		value: 1,
		label: MealTypeMap[EMealType.LUNCH],
	},
	afternoon_snack: {
		value: 1,
		label: MealTypeMap[EMealType.AFTERNOON_SNACK],
	},
	dinner: {
		value: 1,
		label: MealTypeMap[EMealType.DINNER],
	},
}

export enum EOrderDayStatus {
	UPCOMING = 'upcoming',
	PROCESSING = 'processing',
	DELIVERED = 'delivered',
	CANCELLED = 'cancelled',
}

export const OrderDayStatusMap: { [key in EOrderDayStatus]: string } = {
	[EOrderDayStatus.UPCOMING]: 'Nadchodzący',
	[EOrderDayStatus.PROCESSING]: 'Przetwarzany',
	[EOrderDayStatus.DELIVERED]: 'Dostarczony',
	[EOrderDayStatus.CANCELLED]: 'Anulowany',
}

export const orderDayStatuses = generateSelectOptions(EOrderDayStatus, OrderDayStatusMap)
